<script setup lang="ts">
import MSpinnerBall from "../MSpinnerBall";

defineProps<{ size?: string }>();
</script>
<template>
  <m-spinner-ball class="medicus-loading-ball" :size="size" />
</template>
